export default "__VITE_ASSET__BzATJzEb__"